<div class="dialog-container">
  <div class="flex_sb">
    <div class="dialog-header-cross" style="visibility: hidden">
      <img [src]="images.CANCEL" class="img-20" alt="close" />
    </div>
    <div
      class="cl-green fs-50"
      style="text-align: center"
      *ngIf="currState == 'Clock-In'"
    >
      {{ 'STAFF_CENTER.CLOCK_IN' | fallbackTranslate }}
    </div>
    <div
      class="cl-red fs-50"
      style="text-align: center"
      *ngIf="currState == 'Clock-Out'"
    >
      {{ 'STAFF_CENTER.CLOCK_OUT' | fallbackTranslate }}
    </div>
    <div class="dialog-header-cross" (click)="cancel_clicked()">
      <img [src]="images.CANCEL" class="img-20" alt="close" />
    </div>
  </div>

  <div class="content">
    <div class="img_cont" *ngIf="isSuccess">
      <!-- <img src="{{successIcon}}" class="result-img"> -->
      <ng-lottie
        [options]="options"
        (animationCreated)="animationCreated($event)"
      ></ng-lottie>
    </div>

    <div>
      <span class="fs-100 fw-500">
        {{ this.getCurremtTimein12() }}
      </span>
      <span class="fs-60 fw-500">
        {{ this.getCurrentAMPM() }}
      </span>
    </div>
    <div class="fs-36 fw-500">{{ this.getCurrentDate2() }}</div>
    <ng-container *ngIf="isSuccess">
      <div class="fs-22 fw-600 m-t-50" *ngIf="currState == 'Clock-In'">
        {{ user_name }}! {{ 'STAFF_CENTER.YOU_ARE_CLOCKED_IN' | fallbackTranslate }}
      </div>
      <div class="fs-18 fw-600 m-t-5 cl_lgrey" *ngIf="currState == 'Clock-In'">
        {{ 'STAFF_CENTER.YOU_ARE_CLOCKED_IN' | fallbackTranslate }}.
        {{ 'STAFF_CENTER.HAVE_A_GREAT_DAY' | fallbackTranslate }}!
      </div>
      <div class="fs-22 fw-600 m-t-50" *ngIf="currState == 'Clock-Out'">
        {{ user_name }}! {{ 'STAFF_CENTER.YOU_ARE_CLOCKED_OUT' | fallbackTranslate }}
      </div>
      <div class="fs-18 fw-600 m-t-5 cl_lgrey" *ngIf="currState == 'Clock-Out'">
        {{ 'STAFF_CENTER.YOU_ARE_CLOCKED_OUT' | fallbackTranslate }}.
        {{ 'STAFF_CENTER.HAVE_A_GREAT_DAY' | fallbackTranslate }}!
      </div>
    </ng-container>

    <ng-container *ngIf="!isSuccess">
      <div class="fs-22 fw-600 m-t-50">
        {{ 'STAFF_CENTER.HEY' | fallbackTranslate }}! {{ user_name }}
      </div>
      <div class="fs-18 fw-500 m-t-5 cl_lgrey" *ngIf="currState == 'Clock-In'">
        {{ 'STAFF_CENTER.PLEASE_MARK_YOUR_ATTENDANCE' | fallbackTranslate }}
      </div>
      <div class="fs-16 fw-500 m-t-5 cl_lgrey" *ngIf="currState == 'Clock-Out'">
        {{ 'STAFF_CENTER.YOU_ARE_CURRENTLY_CLOCKED_IN' | fallbackTranslate }}:
        {{ data.clock_in_time }}
      </div>
      <div
        class="c-button bc-green m-t-15"
        *ngIf="currState == 'Clock-In'"
        (click)="markAttendance()"
      >
        {{ 'STAFF_CENTER.CLOCK_IN' | fallbackTranslate }}
      </div>
      <div
        class="c-button bc-red m-t-15"
        *ngIf="currState == 'Clock-Out'"
        (click)="markAttendance()"
      >
        {{ 'STAFF_CENTER.CLOCK_OUT' | fallbackTranslate }}
      </div>
    </ng-container>
  </div>
</div>
